// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-forms-listing-detail .login-form, .auth-forms-listing-detail .forgot-password-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadein 0.5s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Listing/modules/ListingDetail/modules/AuthForms/authForms.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;AAAR;AAGI;EACI;IACI,UAAA;EADV;EAIM;IACI,UAAA;EAFV;AACF","sourcesContent":[".auth-forms-listing-detail {\n    .login-form, .forgot-password-form {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        animation: fadein .5s;\n    }\n\n    @keyframes fadeIn {\n        0% {\n            opacity: 0;\n        }\n\n        100% {\n            opacity: 1;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
